import { ScanDataSftpCredentialCreateInput } from '@occc/graphql';

import { ScanDataSubmissionGroupsCreateFormValues } from './scan-data-submission-groups-create.types';

export const convertScanDataSubmissionGroupFormValuesToCreateInput = (
  formValues: ScanDataSubmissionGroupsCreateFormValues,
): ScanDataSftpCredentialCreateInput => {
  return {
    cpg: formValues.tobaccoCompany,
    host: formValues.sftpDetails.submissionURL,
    name: formValues.name || undefined,
    password: formValues.sftpDetails.password,
    port: formValues.sftpDetails.portNumber
      ? parseInt(formValues.sftpDetails.portNumber, 10)
      : undefined,
    submitterID: formValues.sftpDetails.submitterID,
    username: formValues.sftpDetails.username,
    credentialStatus: formValues.submissionType,
  };
};
